import { m as t, c as i } from "./sharedStyles.js";
import { jsx as e, Fragment as a, jsxs as r } from "react/jsx-runtime";
import { uniqueId as o } from "@wds/utils";
import { T as n, b as d, a as s } from "./TableDataCell.js";
import { createUseStyles as l } from "react-jss";

function c({
  name: t,
  colSpan: i
}) {
  return e("th", Object.assign({
    className: "outer-header",
    colSpan: i
  }, {
    children: t
  }));
}

function p({
  pivots: t,
  showStatisticalSignificance: i
}) {
  const r = "inner-header";
  return t ? e(a, {
    children: t.map(({
      name: a,
      totals: d,
      statisticalSignificanceLabel: s
    }, l) => {
      const c = [r];
      l + 1 === t.length && c.push("last-col");
      const p = i && s;
      return e(n, {
        name: a,
        totals: d || void 0,
        title: a,
        className: c.join(" "),
        statisticalSignificanceLabel: p || void 0
      }, o("inner-header-"));
    })
  }) : e("th", {
    className: r
  });
}

function f({
  row: t,
  colSpans: i,
  showStatisticalSignificance: r,
  statisticalSignificanceConfidenceLevel: n
}) {
  return e(a, {
    children: t.data.map(({
      value: t,
      rendered: a,
      statisticalSignificance: s
    }, l) => {
      const c = l + 1 === ((t, i) => {
        let e = 0;
        return i.find(i => (e += i, e > t)), e;
      })(l, i) && "last-col",
            p = r ? {
        label: (null == s ? void 0 : s.label) || "",
        description: null == s ? void 0 : s.description,
        confidenceLevel: n
      } : void 0;

      return e(d, {
        value: a || String(t),
        className: c || void 0,
        statisticalSignificance: p
      }, o("row-"));
    })
  });
}

function h({
  name: t,
  color: i
}) {
  return e(s, {
    name: t,
    title: t,
    color: i,
    identifier: "colors"
  });
}

function b({
  data: a = [{
    name: "",
    data: []
  }],
  options: n = {
    pivots: [{
      name: ""
    }, {
      name: "",
      pivots: [{
        name: ""
      }]
    }]
  }
}) {
  var d, s, b;

  const m = (({
    dataCount: e
  }) => l(a => ({
    multiWaveCrosstab: Object.assign(Object.assign({}, t.table(a)), {
      tableLayout: "fixed",
      "& th": Object.assign(Object.assign({}, t.th(a)), {
        padding: "8px 12px",
        "&:first-of-type": {
          width: i.sizes.dataLabel.fixedWidth
        },
        "&.outer-header": {
          "&:not(:first-of-type)": {
            backgroundColor: "#F7F8FA",
            borderTop: i.border.dark,
            borderRight: i.border.dark,
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px"
          },
          "&:nth-of-type(2)": {
            borderLeft: i.border.dark
          }
        },
        "&.inner-header": {
          whiteSpace: "nowrap",
          paddingBottom: " 4px",
          borderBottom: i.border.light,
          textOverflow: "ellipsis",
          overflow: "hidden",
          "&.last-col": {
            borderRight: i.border.dark
          },
          "&:nth-of-type(2)": {
            borderLeft: i.border.dark
          },
          "&:last-of-type": {
            borderRight: i.border.dark
          }
        }
      }),
      "& td": Object.assign(Object.assign({}, t.td()), {
        padding: "4px 16px",
        textOverflow: "ellipsis",
        borderBottom: i.border.light,
        "&:first-child": {
          textAlign: "left",
          padding: "16px 24px 16px 16px",
          textOverflow: "ellipsis",
          overflow: "hidden"
        },
        "&:not(:first-child)": {
          borderRight: i.border.light,
          width: `calc((100% - ${i.sizes.dataLabel.fixedWidth}) / ${e})`
        },
        "&:nth-of-type(2)": {
          borderLeft: i.border.dark
        },
        "&:last-of-type": {
          borderRight: i.border.dark
        },
        "&.last-col": {
          borderRight: i.border.dark
        }
      }),
      "& tr:last-of-type": {
        "& td:not(:first-of-type)": {
          borderBottom: i.border.dark
        }
      },
      width: "100%",
      minWidth: `calc(${i.sizes.data.minWidth} * ${e} + ${i.sizes.dataLabel.fixedWidth})`,
      maxWidth: `calc(${i.sizes.data.maxWidth} * ${e} + ${i.sizes.dataLabel.fixedWidth})`
    })
  }))())({
    dataCount: a ? null === (s = null === (d = a[0]) || void 0 === d ? void 0 : d.data) || void 0 === s ? void 0 : s.length : 1
  }),
        g = n.pivots.map(({
    pivots: t
  }) => (null == t ? void 0 : t.length) || 0),
        v = (null === (b = n.statisticalSignificance) || void 0 === b ? void 0 : b.enabled) && !!a.find(({
    data: t
  }) => t.find(({
    statisticalSignificance: t
  }) => !!t));

  return a && a.length ? r("table", Object.assign({
    className: m.multiWaveCrosstab
  }, {
    children: [r("thead", {
      children: [e("tr", {
        children: n.pivots.map(({
          name: t
        }, i) => e(c, {
          name: t,
          colSpan: g[i]
        }, o("outer-header-")))
      }), e("tr", {
        children: n.pivots.map(({
          pivots: t
        }) => {
          var i;
          return e(p, {
            pivots: t,
            showStatisticalSignificance: !!(null === (i = n.statisticalSignificance) || void 0 === i ? void 0 : i.enabled)
          }, o("inner-header-"));
        })
      })]
    }), e("tbody", {
      children: a.map(t => {
        var i;
        return r("tr", {
          children: [e(h, {
            name: t.name,
            color: t.color
          }), e(f, {
            row: t,
            colSpans: g,
            showStatisticalSignificance: !!v,
            statisticalSignificanceConfidenceLevel: null === (i = n.statisticalSignificance) || void 0 === i ? void 0 : i.confidenceLevel
          })]
        }, o("row-"));
      })
    })]
  })) : e("div", {});
}

export { b as M };